/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
import {
  TeamResponse,
  GenericErrorResponse,
  ReportItem,
} from './responses';

import {
  CreateTeamPayload,
  UpdateGoalPayload,
} from './requests';

import { ContentType, HttpClient, RequestParams } from './httpClient';

export class Teams<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * @tags Team
   * @name getTeams
   * @request GET:/teams
   * @description Retrieve a list of all teams.
   * @param {RequestParams} params Additional request parameters.
   * @response `200` `TeamResponse` Success
   */
  getTeams = (params: RequestParams = {}) =>
    this.request<TeamResponse[], GenericErrorResponse>({
      path: '/teams',
      method: 'GET',
      format: 'json',
      secure: true,
      ...params,
    });

  /**
   * @tags Team
   * @name getTeam
   * @request GET:/team/{teamId}
   * @description Get a team by its ID.
   * @param {string} teamId The ID of the team to retrieve.
   * @param {RequestParams} params Additional request parameters.
   * @response `200` `TeamResponse` Success
   */
  getTeam = (teamId: string, params: RequestParams = {}) =>
    this.request<TeamResponse, GenericErrorResponse>({
      path: `/teams/${teamId}`,
      method: 'GET',
      format: 'json',
      secure: true,
      ...params,
    });

    /**
     * @tags Report, Team
     * @name getReports
     * @request GET:/teams/${teamId}/reports
     * @description Get a Report by its ID.
     * @param {string} teamId The ID of the team owning the reports to retrieve.
     * @param {RequestParams} params Additional request parameters.
     * @response `200` `ReportResponse` Success
     */
    getReports = (teamId: string, params: RequestParams = {}) =>
      this.request<ReportItem[], GenericErrorResponse>({
        path: `/teams/${teamId}/reports`,
        method: 'GET',
        format: 'json',
        secure: true,
        ...params,
      });
  
    /**
     * @tags Report, Team
     * @name getReport
     * @request GET:/teams/${ReportId}/report/{ReportId}
     * @description Retrieve a list of all Reports.
     * @param {string} teamId The ID of the team to owning the reports.
     * @param {string} reportId The ID of the report to retrieve.
     * @param {RequestParams} params Additional request parameters.
     * @response `200` `ReportResponse` Success
     */
    getReport = (teamId:string, reportId:string, params: RequestParams = {}) =>
      this.request<ReportItem, GenericErrorResponse>({
        path: `/teams/${teamId}/report/${reportId}`,
        method: 'GET',
        format: 'json',
        secure: true,
        ...params,
      });
    /**
     * @tags Team
     * @name getTeam
     * @request POST:/teams
     * @description Create a new team with the provided details.
     * @param  {CreateTeamPayload} data The payload containing the team details.
     * @param {RequestParams} params Additional request parameters.
     * @response `200` `TeamResponse` Success
     */
    createTeam = (data: CreateTeamPayload, params: RequestParams = {}) =>
      this.request<TeamResponse, GenericErrorResponse>({
        path: '/teams',
        method: 'POST',
        format: 'json',
        body: data,
        type: ContentType.Json,
        secure: true,
        ...params,
      });

      /**
     * @tags Team
     * @name updateTeam
     * @request PATCH:/teams/{id}
     * @description Update an existing team with the provided details.
     * @param {string} id The ID of the team to update.
     * @param {CreateTeamPayload} data The payload containing the updated team details.
     */
    updateTeam = (id: string, data: CreateTeamPayload, params: RequestParams = {}) =>
      this.request<TeamResponse[], GenericErrorResponse>({
        path: `/teams/${id}`,
        method: 'PATCH',
        format: 'json',
        body: data,
        type: ContentType.Json,
        secure: true,
        ...params,
      });

    getSubTeams = (teamId: string, params: RequestParams = {}) =>
      this.request<TeamResponse[], GenericErrorResponse>({
        path: `/teams/${teamId}/teams`,
        method: 'GET',
        format: 'json',
        secure: true,
        ...params,
      });

    /**
     * @tags Goal, Team
     * @name updateGoal
     * @request PUT:/teams/{teamId}/goals/{goalType}
     * @description Update the goal value and description for a given goal type.
     * @param {string} teamId The ID of the team owning the goal.
     * @param {string} goalType The goal key from the report configuration.
     * @param {UpdateGoalPayload} data The new goal value, description and optional group id.
     * @param {RequestParams} params Additional request parameters.
     */
    updateGoal = (teamId: string, goalType: string, data: UpdateGoalPayload, params: RequestParams = {}) =>
      this.request<unknown, GenericErrorResponse>({
        path: `/teams/${teamId}/goals/${goalType}`,
        method: 'PUT',
        format: 'json',
        body: data,
        type: ContentType.Json,
        secure: true,
        ...params,
      });

    /**
     * @tags Goal, Team
     * @name deleteGoal
     * @request DELETE:/teams/{teamId}/goals/{goalType}
     * @description Delete the goal for a given goal type.
     * @param {string} teamId The ID of the team owning the goal.
     * @param {string} goalType The goal key from the report configuration.
     * @param {RequestParams} params Additional request parameters, including optional groupId query param.
     */
    deleteGoal = (teamId: string, goalType: string, query?: { groupId?: string }, params: RequestParams = {}) =>
      this.request<unknown, GenericErrorResponse>({
        path: `/teams/${teamId}/goals/${goalType}`,
        method: 'DELETE',
        format: 'json',
        query,
        secure: true,
        ...params,
      });
    }
